import sdk from '@beastshop/sdk' 

export function getEnv () {
  return new Promise((resolve, reject) => {
    sdk.adapter.invoke(function () {
      resolve(sdk)
    })
  })
}



// WEBPACK FOOTER //
// ./static/sdk/index.js